import { HIDE_SNACKBAR, REMOVE_NOTIFICATION, RENDER_NOTIFICATION, RING_START, SHOW_SNACKBAR } from "../constants";

let initialState = {};


export const SnackbarReducer = (state = initialState, action) => {
	switch (action.type) {
		case SHOW_SNACKBAR:
		case HIDE_SNACKBAR:
			return action.data;
		default:
			return state;
	}
};


export const NotificationReducer = (state = initialState, action) => {
	switch (action.type) {
		case RENDER_NOTIFICATION:
		case REMOVE_NOTIFICATION:
			return { ...state, ...action.data };
		default:
			return state;
	}
};


export const CallNotificationReducer = (state = initialState, action) => {
	switch (action.type) {
		case RING_START:
			return { ...state, ...action.data };
		default:
			return state;
	}
};
